export default __webpack_public_path__ + "static/media/bkg-location-lifestyle-2.e6d10847.jpg";